module.exports = __webpack_public_path__ + "static/media/8833a7ef.jpg";